import React, { useEffect } from 'react';
import './Navbar.scss';
import logo from './../../assets/logo.png';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdLanguage } from "react-icons/md";
import { FaInstagram } from "react-icons/fa";

const Navbar = () => {
    const { t } = useTranslation();

    const languages = [
        { code: 'DE', name: t('navbar.languages.german') },
        { code: 'EN', name: t('navbar.languages.english') },
        { code: 'UA', name: t('navbar.languages.ukrainian') },
        { code: 'RU', name: t('navbar.languages.russian') },
        { code: 'PL', name: t('navbar.languages.polish') }
    ];

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                document.body.classList.add('scrolled');
            } else {
                document.body.classList.remove('scrolled');
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navbarItems = [
        {
            name: t('navbar.home'),
            path: '/',
        },
        {
            name: t('navbar.singleService'),
            path: '/leistungen', // German-friendly path
        },
        {
            name: t('navbar.career'),
            path: '/karriere',
        },
        {
            name: t('navbar.contactUs'),
            path: '/kontakt', // German-friendly path
        }
    ];

    return (
        <>
            <div className='main-nav'>
                <div className="container">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        {/* Logo */}
                        <Link className="navbar-brand" to="/">
                            <img src={logo} alt="logo" />
                        </Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            {/* Navbar Link */}
                            <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                               { 
                                navbarItems.map((navSingle, index) =>
                                    <li key={index} className="nav-item">
                                        <Link className="nav-link" to={navSingle.path}>{navSingle.name}</Link>
                                    </li>
                                    ) 
                                }
                            </ul>
                            
                            {/* Navbar Button */}
                            <div className="d-flex align-items-center navbar-actions">
                                <div className="navbar-social">
                                    <a 
                                        href="https://www.instagram.com/zap_boretskyi" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="instagram-link"
                                        aria-label="Instagram"
                                    >
                                        <FaInstagram />
                                    </a>
                                </div>
                                <div className="navbar-languages">
                                    <div className="languages-header">
                                        <MdLanguage className="language-icon" />
                                        <span className="languages-label">{t('navbar.languages.title')}</span>
                                    </div>
                                    <div className="languages-list">
                                        {languages.map((lang, index) => (
                                            <span key={index} className="language-badge" title={lang.name}>
                                                {lang.code}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                                <div className="theme-btn">
                                    <Link to="/kontakt">{t('navbar.bookAppointment')}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        </>
    );
};

export default Navbar;